import { configNoHeaders ,configWithTokenId } from '@api/constructor-api';

const checkStatusFriends = async(payload) => {
    return await configNoHeaders(async(API) => {
        return API.post(`get-friend-status`,payload)
    })
}

const getLineTokenHandler = async(payload) => {
    return await configNoHeaders(async(API) => {
        return API.post(`get-line-token`,payload)
    })
}

const seveDateAddLineFriend = async(payload) => {
    return await configWithTokenId(async(API) => {
        return API.patch(`info/update-add-line`,payload)
    })
}

export default {
    checkStatusFriends,
    getLineTokenHandler,
    seveDateAddLineFriend
 }